<template>
    <div class="worry_free">
        <!-- 无忧服务 -->
        <p class="text">{{worryFree.desc}}</p>
        <img class="pc" :src="worryFree.image" alt=""/>
        <img class="mobile" :src="worryFree.web_image" alt=""/>
        <p class="title">无忧服务包</p>
        <SwiperBanner :data="worryFree.package_images" :mobileData="worryFree.web_package_images"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import SwiperBanner from '../../components/swiperBanner.vue';
export default {
    name: "worryFree",
    data() {
        return {
            
        };
    },
    computed: {
        ...mapState(['worryFree']),
    },
    components: {
        SwiperBanner
        
    },
    mounted() {
        this.$store.dispatch('getWorryFree');
    },
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<style scoped lang="scss">
.worry_free{
    .text{
        margin-bottom: .1rem;
    }
    .mobile{
        display: none;
    }
    .title{
        font-size: .2rem;
        text-align: center;
        margin: .3rem 0;
    }
    @media only screen and (max-width: 1200px) {
        .pc{
            display: none;
        }
        .mobile{
            display: block;
        }
        .text{
            padding: 0 1rem;
            margin-bottom: .5rem;
        }
        .title{
            font-size: .72rem;
            padding: 1rem 0 .8rem;
            line-height: 1;
            margin: 0;
        }
    }
}
</style>